module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top saveRuleChanges",
    attrs: {
      "dialog": "modal-lg",
      "footer": false,
      "header": false
    },
    on: {
      "close": function($event) {
        $event.stopPropagation();
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "p-4"
  }, [(_vm.type === 'rule') ? _c('div', [_c('h2', {
    staticClass: "mb-4 text-center bold"
  }, [_vm._v("Rule Change Confirmation")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("You are about to modify this rule. This action will have "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("significant implications")]), _vm._v(" as it will affect multiple rule groups applied to various products. Consequently, prices may change, and the conditions for opening or closing sales channels may be adjusted based on occupancy and the new conditions set.")]), _vm._v(" "), _c('p', {
    staticClass: "bold mt-4"
  }, [_vm._v("Do you wish to proceed with these changes and apply the new parameters?")])]) : _vm._e(), _vm._v(" "), (_vm.type === 'ruleGroup') ? _c('div', [_c('h2', {
    staticClass: "mb-4 text-center bold"
  }, [_vm._v("Rule Group Change Confirmation")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("You are about to modify this rule. This action will have "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("significant implications")]), _vm._v(" as it will affect multiple rule groups applied to various products. Consequently, prices may change, and the conditions for opening or closing sales channels may be adjusted based on occupancy and the new conditions set.")]), _vm._v(" "), _c('p', {
    staticClass: "bold mt-4"
  }, [_vm._v("Do you wish to proceed with these changes and apply the new parameters?")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-4 pt-3 mt-3 border-top-light"
  }, [_c('radio', {
    attrs: {
      "name": "resetAll",
      "value": true
    },
    model: {
      value: (_vm.optionSelected),
      callback: function($$v) {
        _vm.optionSelected = $$v
      },
      expression: "optionSelected"
    }
  }, [_c('span', {
    staticClass: "darkest"
  }, [_vm._v("Yes, apply changes.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {}, [_c('button', {
    staticClass: "btn tertiary",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "flexGrow1 text-right"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": !_vm.optionSelected
    },
    on: {
      "click": _vm.pressBtn
    }
  }, [_vm._v("Submit")])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1a72a4f1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a72a4f1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/RuleSaveChanges.vue
// module id = 2100
// module chunks = 0